import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Card,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Avatar,
    Button, CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StudentCards from "./UserProfileCard";
import StudentService from "./Locality/Service/studentService";
import EventService from "./Locality/Service/eventService";
import AttendenceService from "./Locality/Service/attendenceService";
import ActivityService from "./Locality/Service/activityService";
import TeacherNotesService from "./Locality/Service/teacherNotesService";
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        maxWidth: 1000,
        margin: "0 auto",
        padding: theme.spacing(3),
    },
    section: {
        marginTop: theme.spacing(4),
    },
    sectionTitle: {
        fontWeight: 700,
        color: theme.palette.primary.main,
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
    tablePaper: {
        overflow: "hidden",
        borderRadius: 12,
    },
    headCell: {
        fontWeight: 700,
        background: theme.palette.grey[100],
    },
    profileCard: {
        padding: theme.spacing(2),
        borderRadius: 16,
    },
    profileAvatar: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    noteCard: {
        padding: theme.spacing(2),
        borderRadius: 12,
        height: "100%",
    },
      root: {
    padding: theme.spacing(2),
  },
  card: {
    borderRadius: 16,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    },
  },
  titleTeacher: {
    color: "#1565C0",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  titlePrincipal: {
    color: "#D32F2F",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  text: {
    margin: "12px 0",
    color: "#333",
  },
  authorBox: {
    display: "flex",
    alignItems: "center",
    marginTop: 12,
  },
  avatar: {
    backgroundColor: "#1976D2",
    marginRight: 10,
  },
  authorName: {
    fontWeight: "bold",
    fontSize: 14,
  },
  authorRole: {
    fontSize: 12,
    color: "#888",
  },
}));

export default function MyStoryPage() {
    const classes = useStyles();
    const [eventList, setEventList] = useState([]);
    const [getReport, setGetReport] = useState([]);
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const [addUserPermitionsList, setUserPermitionsList] = useState({ studentDetailsEdit: false, studentDetailsDelete: false });
    const [monthWiseAttendance, setMonthWiseAttendance] = useState([]);
    const [activityPerformance, setActivityPerformance] = useState({});
    const [studentEvent, setStudentEvent] = useState({});
    const [teacherNotesList, setTeacherNotesList] = useState([]);
    var [error, setError] = useState(null);

    const [studentList, setStudentList] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);
    useEffect(() => {
        fetchStudentList();

    }, []);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const onStudentSelect = (id, classId) => {
        const student = studentList.find(
            (s) => s._id === id && s.classId._id === classId
        );


        const age = calculateAge(student.dob);
        student.age = age;
        setSelectedStudent(student);
    };

    const handleStudentClick = (studentId, classId, dob) => {
        // Update selected student

        onStudentSelect(studentId, classId);
        // setSelectedStudentId(studentId);
        getMonthWiseAttendance(studentId);
        getStudentActivityPerformance(studentId);
        // Fetch data for the selected student
        getEventList(studentId, classId);
        getStudentAttendeceReport(studentId, classId);
        getStudentEvent(studentId, classId);
        getTeacherNotesList(studentId, classId);
        // This will calculate ages for all students

        // You can now fetch the student's assignments or do anything with this ID
    };
    const calculateAge = (dob) => {
        if (!dob) return null;
        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };
    const getEventList = (studentId, classId) => {
        EventService.findEventList({ studentId, classId })
            .then((res) => {
                const formattedEvents = res.map((event) => ({
                    ...event,
                    eventStudentDetailsListId: event.eventStudentDetailsListId.length ? event.eventStudentDetailsListId[0] : {},

                }));
                setEventList(formattedEvents);
            })
            .catch((err) => console.error(err));
    };
    const getMonthWiseAttendance = (studentId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));


        const report = JSON.parse(localStorage.getItem("userDetail"));

        const keys = { "schooleId": report.schooleId, "studentId": studentId, }



        AttendenceService.getMonthWiseAttendance(keys)
            .then((res) => {

                setMonthWiseAttendance(res.data);
            })
            .catch((err) => console.error(err));
    };

    const getStudentEvent = (studentId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));


        const report = JSON.parse(localStorage.getItem("userDetail"));

        const keys = { "schooleId": report.schooleId, "studentId": studentId, }



        EventService.getStudentEvent(keys)
            .then((res) => {


                setStudentEvent(res || {});

            })
            .catch((err) => console.error(err));
    };
    const getStudentActivityPerformance = (studentId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));


        const report = JSON.parse(localStorage.getItem("userDetail"));

        const keys = { "schooleId": report.schooleId, "studentId": studentId, }



        ActivityService.getStudentActivityPerformance(keys)
            .then((res) => {


                setActivityPerformance(res || {});

            })
            .catch((err) => console.error(err));
    };
    const getStudentAttendeceReport = (studentId, classId) => {
        const report = JSON.parse(localStorage.getItem("userDetail"));
        // let newstartDate1 = startDate1 ? startDate1 : null;
        // const newendDate1 = endDate1 ? endDate1 : null;

        const keys = { "schooleId": report.schoolId, "studentId": studentId, "classId": classId }
        AttendenceService.getStuAttReport(keys).then((res) => {
            setGetReport(res);

        }).catch((err) => {
        });
    };

    // Function to calculate age difference between two dates
    const getTeacherNotesList = () => {
        TeacherNotesService.getAllTeacherNotes().then((res) => {
            debugger;

            setTeacherNotesList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }



    const fetchStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        StudentService.findStudentList({ userId: userDetails._id })
            .then((res) => {
                const mappedStudents = res.map((student) => ({
                    ...student,
                    fullName: `${student.firstName} ${student.lastName}`,
                }));
                setStudentList(mappedStudents);
                // if (mappedStudents.length > 0) {
                //   getEventList(mappedStudents[0]._id, mappedStudents[0].classId._id);
                // }

            })
            .catch((err) => console.error(err));
    };
    // const attendanceRows = [
    //     { month: "Jan", presentDays: 20, absentDays: 2, lateDays: 1 },
    //     { month: "Feb", presentDays: 18, absentDays: 3, lateDays: 0 },
    // ];

    // const activityPerformanceRows = [
    //     { activity: "Drawing", score: "A+" },
    //     { activity: "Reading", score: "A" },
    // ];


    const getMonthName = (monthNumber) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        // monthNumber: 1 for Jan, 12 for Dec
        return monthNames[monthNumber - 1] || "";
    }

    return (
        <>
            <Card>
                {studentList.length > 1 && (
                    <Box style={{ margin: 15 }}>
                        <StudentCards
                            studentList={studentList}
                            onStudentSelect={handleStudentClick}
                        />
                    </Box>
                )}
            </Card>

            <Box className={classes.pageContainer}>
                <Typography variant="h5" className={classes.sectionTitle}>
                    MY STORY !!
                </Typography>

                <Card className={classes.profileCard} elevation={3}>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12} md={8}>
                            <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                                Hi, This is
                            </Typography>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 700,
                                    color: '#FF6B35',
                                    textTransform: 'uppercase',
                                    marginBottom: '16px'
                                }}
                            >
                                {selectedStudent?.fullName || "Select a student"}
                            </Typography>

                            {selectedStudent && (
                                <>
                                    <Paper
                                        elevation={0}
                                        style={{
                                            backgroundColor: '#F5F7FA',
                                            padding: '16px',
                                            borderRadius: '8px',
                                            marginBottom: '16px'
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12}>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ marginRight: '8px' }}>👥</span>
                                                    <Typography variant="body2">
                                                        Age:  {selectedStudent?.age}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ marginRight: '8px' }}>🎓</span>
                                                    <Typography variant="body2">
                                                        Class: {selectedStudent.classId.className}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Paper>

                                    <Typography variant="body2" color="textSecondary" style={{ lineHeight: 1.6 }}>
                                        I'm a student at Montessori School, and I love learning through exploring and discovering new things.
                                        I was born in Portland, and I've always been curious about the world around me—whether it's how plants grow
                                        or how colors mix to make new shades.
                                    </Typography>
                                </>
                            )}
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                <Avatar
                                    className={classes.profileAvatar}
                                    src={selectedStudent?.imageURL?.[0] || "/images/Admin icon.svg"}
                                    style={{
                                        width: '200px',
                                        height: '200px',
                                        border: '4px solid #F5F7FA'
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Card>

                <Box className={classes.section}>
                    <Typography variant="h6" align="center" gutterBottom>
                        Attendance
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={1}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Month</TableCell>
                                    <TableCell className={classes.headCell} align="center">Present</TableCell>
                                    <TableCell className={classes.headCell}align="center">Absent</TableCell>
                                    <TableCell className={classes.headCell}align="center">Total</TableCell>
                                    <TableCell className={classes.headCell}align="center">Present %</TableCell>
                                    <TableCell className={classes.headCell}align="center">Absent %</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {monthWiseAttendance.length > 0 ? (
                                    monthWiseAttendance.map((row, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{getMonthName(row._id?.month)} {row._id?.year}</TableCell>
                                            <TableCell align="center" style={{ color: "#2E7D32" }}>
                                                {row.presentCount}
                                            </TableCell>
                                            <TableCell align="center" style={{ color: "#D32F2F" }}>
                                                {row.absentCount}
                                            </TableCell>
                                            <TableCell align="center">{row.totalCount}</TableCell>
                                            <TableCell align="center">{row.presentPercentage}</TableCell>
                                            <TableCell align="center">{row.absentPercentage}</TableCell>

                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>

                <Box className={classes.section}>
                    <Typography variant="h6" align="center" gutterBottom>
                        Activity Performance Report
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={1}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Activity</TableCell>
                                    <TableCell className={classes.headCell} align="center">Strong Area</TableCell>
                                    <TableCell className={classes.headCell} align="center">Developing Area</TableCell>
                                    <TableCell className={classes.headCell} align="center">Need Action</TableCell>


                                </TableRow>
                            </TableHead>
                            <TableBody>


                                <TableRow>
                                    <TableCell align="center">{activityPerformance.totalActivities}</TableCell>
                                    <TableCell align="center">{activityPerformance.strongArea}</TableCell>
                                    <TableCell align="center">{activityPerformance.developingArea}</TableCell>
                                    <TableCell align="center">{activityPerformance.needsAction}</TableCell>
                                </TableRow>


                            </TableBody>
                        </Table>
                    </Paper>
                </Box>

                <Box className={classes.section}>
                    <Typography variant="h6" align="center" gutterBottom>
                        Assignments
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={1}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Number Of Activities</TableCell>
                                    <TableCell className={classes.headCell} align="center">On Time</TableCell>
                                    <TableCell className={classes.headCell} align="center"> Delayed</TableCell>
                                    <TableCell className={classes.headCell} align="center"> Pending</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center">{studentEvent.total}</TableCell>
                                    <TableCell align="center">{studentEvent.submitted}</TableCell>
                                    <TableCell align="center">{studentEvent.resubmitNotSubmitted}</TableCell>
                                    <TableCell align="center">{studentEvent.notSubmitted}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
                <br></br>
                <br></br>
                <Box className={classes.root}>

                    <Typography variant="h6" align="center" gutterBottom>
                        Notes
                    </Typography>
                    <Grid container spacing={3} justify="center" style={{ marginTop: 20 }}>
                        {teacherNotesList.map((note, index) => (
                            <Grid item xs={12} md={6} key={index}>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Typography
                                            variant="h6"
                                            className={note.isTeacher ? classes.titleTeacher : classes.titlePrincipal}
                                        >
                                            {/* <PersonIcon fontSize="small" />
                                            {note.role === "schoole"
                                                ? note.schooleId?.name || "Note"
                                                : note.teacherId?.teacherName || "Note"}             */}
                                            {/* <PersonIcon fontSize="small" />{note.userId.role || ""} */}
                                        </Typography>
                                        <Typography className={classes.notes}>
                                            {note.notes || "No content available."}
                                        </Typography>
                                        <br></br>
                                        <Box className={classes.authorBox}>

                                            <Box textAlign="center">
                                                <Typography className={classes.authorName}>
                                                    {note.userId.role?.toLowerCase() === "schoole"
                                                    
                                                        ? note.schooleId?.name || ""
                                                        : note.teacherId?.teacherName || ""}
                                                </Typography>

                                                <Typography>
                                                   {note.userId.role?.toLowerCase() === "schoole"
    ? "PRINCIPAL"
    : note.userId.role}
                                                </Typography>
                                            
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                
            </Box>
        </>
    );
}
